var getLanguage = function() {
    return (navigator && ((navigator.languages && navigator.languages[0]) ||
        navigator.language || navigator.userLanguage)) || undefined;
};

export default {
    language: getLanguage()
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/amplitude-js/src/language.js
// module id = kdtp
// module chunks = 4